import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "recipe-detail-page-top-view" }
const _hoisted_2 = { class: "recipe-detail-page-title-view" }
const _hoisted_3 = { class: "titleFavoriteIcon title-favorite-icon-top" }
const _hoisted_4 = { class: "titleFavoriteIconText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RecipeDetailView = _resolveComponent("RecipeDetailView")
  const _component_DetailBottomBar = _resolveComponent("DetailBottomBar")
  const _component_IngredientsDialog = _resolveComponent("IngredientsDialog")
  const _component_MyListFolderDialog = _resolveComponent("MyListFolderDialog")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: "recipe-detail-page-view",
      ref: "detailScroll",
      onScrollPassive: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onScroll($event)))
    }, [
      _createVNode(_component_RecipeDetailView, {
        detail: _ctx.recipeDetailInfo,
        selectThemeType: _ctx.selectThemeType,
        selectVariationType: _ctx.selectVariationType,
        update: _ctx.updateDetailInfo,
        applianceData: _ctx.applianceData,
        attachmentList: _ctx.attachmentList,
        isLogin: _ctx.isLogin,
        pageScrollTop: _ctx.pageScrollTop,
        recipeComment: _ctx.recipeComment,
        onClickTheme: _ctx.clickTheme,
        onClickVariation: _ctx.clickVariation,
        onSetInstructionItemPosition: _ctx.setInstructionItemPosition,
        onSetDetailViewBottomPosition: _ctx.setDetailViewBottomPosition,
        onClickBistroSend: _ctx.clickBistroSend,
        onClickBistroSendLink: _ctx.clickBistroSendLink,
        onClickMyApplianceLink: _ctx.clickMyApplianceLink
      }, null, 8, ["detail", "selectThemeType", "selectVariationType", "update", "applianceData", "attachmentList", "isLogin", "pageScrollTop", "recipeComment", "onClickTheme", "onClickVariation", "onSetInstructionItemPosition", "onSetDetailViewBottomPosition", "onClickBistroSend", "onClickBistroSendLink", "onClickMyApplianceLink"])
    ], 544),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _withDirectives(_createVNode("div", _mergeProps({
          class: "titleFavoriteIconView",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickFarvorite(...args)))
        }, [_ctx.addRecipeMyList, _ctx.deleteRecipeMyList]), [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, _toDisplayString(_ctx.getFavoriteIconText()), 1)
          ])
        ], 16), [
          [_vShow, _ctx.isShowFavorite]
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_DetailBottomBar, {
      class: "recipe-detail-page-bottom-bar-area",
      stepNextEnable: _ctx.stepNextEnable,
      stepPrevEnable: _ctx.stepPrevEnable,
      onClickBottomItem: _ctx.clickBottomItem
    }, null, 8, ["stepNextEnable", "stepPrevEnable", "onClickBottomItem"]), [
      [_vShow, _ctx.isShowBottomBar]
    ]),
    _createVNode(_component_IngredientsDialog, {
      detail: _ctx.recipeDetailInfo,
      showDialog: _ctx.isShowIngredientsDialog,
      selectThemeType: _ctx.selectThemeType,
      selectVariationType: _ctx.selectVariationType,
      onClickTheme: _ctx.clickTheme,
      onClickVariation: _ctx.clickVariation,
      onCloseClick: _ctx.closeIngredientsDialog
    }, null, 8, ["detail", "showDialog", "selectThemeType", "selectVariationType", "onClickTheme", "onClickVariation", "onCloseClick"]),
    _createVNode(_component_MyListFolderDialog, {
      showDialog: _ctx.isShowMyListFolderDialog,
      onCloseClick: _ctx.closeMyListFolderDialog,
      onPositiveClick: _ctx.clickAddMyList,
      onSelectCheck: _ctx.selectCheck
    }, null, 8, ["showDialog", "onCloseClick", "onPositiveClick", "onSelectCheck"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: 9,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      negativeLabel: _ctx.ERROR_BUTTON_LABEL,
      onNegativeClick: _ctx.closeError
    }, null, 8, ["isShowDialog", "title", "message", "negativeLabel", "onNegativeClick"])
  ]))
}